import request from '@/utils/request'

// 分页查询房东收租记录信息
export function getPageList(params) {
  return request({
    url: '/hrApi/ownerCollectRecord',
    method: 'get',
    params: params
  })
}

// 获取房东收租记录列表
export function getList(params) {
  return request({
    url: '/hrApi/ownerCollectRecord/list',
    method: 'get',
    params: params
  })
}

// 新增或编辑房东收租记录
export function saveOrUpdateData(data) {
  return request({
    url: '/hrApi/ownerCollectRecord',
    method: 'post',
    data: data
  })
}

// 删除房东收租记录
export function deleteData(id) {
  return request({
    url: '/hrApi/ownerCollectRecord/' + id,
    method: 'delete'
  })
}

// 收租
export function confirmRecord(data) {
  return request({
    url: '/hrApi/ownerCollectRecord/confirm',
    method: 'put',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/ownerCollectRecord.js